module.exports = __webpack_public_path__ + "img/pic1.2b0f4aa1.png";